const PDFConfigModule = (() => {
    const increments = {
        inches: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
        centimeters: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0, 1.1, 1.2, 1.3, 1.4, 1.5],
        millimeters: Array.from({ length: 25 }, (_, i) => i + 1),
        pixels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100]
    };

    var modal = null;
    var closeButton = null;

    const populateMargins = (margin) => {
        try {
            const unit = document.getElementById(`page-setup-${margin}-margin-unit`)?.value || 'px';
            const marginSelect = document.getElementById(`page-setup-${margin}-margin`);
            if (!marginSelect) return;

            const maxPixelValue = 45;

            // Calculate max values that convert to 45px for inches, cm, and mm
            const maxInches = maxPixelValue / 96; // Convert 45px to inches
            const maxCm = maxPixelValue / 37.795; // Convert 45px to cm
            const maxMm = maxPixelValue / 3.7795; // Convert 45px to mm

            marginSelect.innerHTML = ''; // Clear existing options

            let options = [];
            switch (unit) {
                case 'in':
                    // Limit inches to the max that converts to 45px only for 'left' and 'right' margins
                    options = (margin === 'left' || margin === 'right')
                        ? increments.inches.filter(value => value <= maxInches)
                        : increments.inches;
                    break;
                case 'cm':
                    // Limit cm to the max that converts to 45px only for 'left' and 'right' margins
                    options = (margin === 'left' || margin === 'right')
                        ? increments.centimeters.filter(value => value <= maxCm)
                        : increments.centimeters;
                    break;
                case 'mm':
                    // Limit mm to the max that converts to 45px only for 'left' and 'right' margins
                    options = (margin === 'left' || margin === 'right')
                        ? increments.millimeters.filter(value => value <= maxMm)
                        : increments.millimeters;
                    break;
                case 'px':
                    // Limit pixels to a max of 45px only for 'left' and 'right' margins
                    options = (margin === 'left' || margin === 'right')
                        ? increments.pixels.filter(value => value <= maxPixelValue)
                        : increments.pixels;
                    break;
                default:
                    console.warn(`Unknown unit: ${unit}. Defaulting to pixels.`);
                    options = increments.pixels;
                    break;
            }
            options.forEach(value => {
                const option = document.createElement('option');
                option.value = value;
                option.textContent = value;
                marginSelect.appendChild(option);
            });
        } catch (error) {
            console.error(`Error populating margins for ${margin}:`, error);
        }
    };

    const handleTitleInputVisibility = () => {
        const dropdowns = ['left-section', 'middle-section', 'right-section'];
        dropdowns.forEach(section => {
            try {
                const dropdown = document.getElementById(`page-setup-${section}`);
                const titleInputSection = document.getElementById(`page-setup-${section}-title`);
                const dateFormatSection = document.getElementById(`page-setup-${section}-date-format`);
                const numberDropdownSection = document.getElementById(`page-setup-${section}-number-dropdown`);
                const prefixDropdownSection = document.getElementById(`page-setup-${section}-prefix-dropdown`);

                // Hide both sections initially
                if (titleInputSection) titleInputSection.style.display = 'none';
                if (dateFormatSection) dateFormatSection.style.display = 'none';
                if (numberDropdownSection) numberDropdownSection.style.display = 'none';
                if (prefixDropdownSection) prefixDropdownSection.style.display = 'none';

                // Show sections based on the dropdown selection
                if (dropdown?.value === '{{title}}') {
                    titleInputSection.style.display = 'block';
                } else if (dropdown?.value === '{{date}}') {
                    dateFormatSection.style.display = 'block';
                } else if (dropdown?.value === '{{pageNumber}}') {
                    numberDropdownSection.style.display = 'block'; // Show the number dropdown
                } else if (dropdown?.value === '{{pageNumber / totalPages}}') {
                    prefixDropdownSection.style.display = 'block'; // Show the number dropdown
                }
            } catch (error) {
                console.error(`Error handling visibility for section ${section}:`, error);
            }
        });
    };

    const generatePDFConfig = () => {
        try {

            // Get header values
            const leftHeader = document.getElementById('page-setup-left-header')?.value || '';
            const centerHeader = document.getElementById('page-setup-center-header')?.value || '';
            const rightHeader = document.getElementById('page-setup-right-header')?.value || '';

            const leftSection = document.getElementById('page-setup-left-section')?.value || '';
            const middleSection = document.getElementById('page-setup-middle-section')?.value || '';
            const rightSection = document.getElementById('page-setup-right-section')?.value || '';

            const customLeftTitle = document.getElementById('page-setup-left-custom-title')?.value || 'Untitled';
            const customMiddleTitle = document.getElementById('page-setup-middle-custom-title')?.value || 'Untitled';
            const customRightTitle = document.getElementById('page-setup-right-custom-title')?.value || 'Untitled';

            const topMargin = document.getElementById('page-setup-top-margin')?.value || '0'; // Default to 0
            const topMarginUnit = document.getElementById('page-setup-top-margin-unit')?.value || 'px';

            const bottomMargin = document.getElementById('page-setup-bottom-margin')?.value || '0'; // Default to 0
            const bottomMarginUnit = document.getElementById('page-setup-bottom-margin-unit')?.value || 'px';

            const leftMargin = document.getElementById('page-setup-left-margin')?.value || '0'; // Default to 0
            const leftMarginUnit = document.getElementById('page-setup-left-margin-unit')?.value || 'px';

            const rightMargin = document.getElementById('page-setup-right-margin')?.value || '0'; // Default to 0
            const rightMarginUnit = document.getElementById('page-setup-right-margin-unit')?.value || 'px';

            const pageSize = document.getElementById('page-setup-page-size')?.value || getPageSizeByLocale();

            const leftDateFormat = document.getElementById('page-setup-left-section')?.value === '{{date}}' ? document.getElementById('page-setup-left-date-format')?.value : null;
            const middleDateFormat = document.getElementById('page-setup-middle-section')?.value === '{{date}}' ? document.getElementById('page-setup-middle-date-format')?.value : null;
            const rightDateFormat = document.getElementById('page-setup-right-section')?.value === '{{date}}' ? document.getElementById('page-setup-right-date-format')?.value : null;

            const fontSize = document.getElementById('page-setup-font-size')?.value || '14';
            const fontStyle = document.getElementById('page-setup-font-style')?.value || 'normal';
            const fontColor = document.getElementById('page-setup-font-color')?.value || '#000000';

            // Get the page number prefix
            const leftPageNumberPrefix = document.getElementById('page-setup-left-number')?.value || '';
            const middlePageNumberPrefix = document.getElementById('page-setup-middle-number')?.value || '';
            const rightPageNumberPrefix = document.getElementById('page-setup-right-number')?.value || '';

            const leftPageSetuprPrefix = document.getElementById('page-setup-left-prefix')?.value || '';
            const middlePageSetupPrefix = document.getElementById('page-setup-middle-prefix')?.value || '';
            const rightPageSetupPrefix = document.getElementById('page-setup-right-prefix')?.value || '';

            const config = {
                pageSize,
                margins: {
                    top: `${topMargin}${topMarginUnit}`,
                    bottom: `${bottomMargin}${bottomMarginUnit}`,
                    left: `${leftMargin}${leftMarginUnit}`,
                    right: `${rightMargin}${rightMarginUnit}`
                },
                header: {
                    left: { default: leftHeader },
                    center: { default: centerHeader },
                    right: { default: rightHeader }
                },
                footer: {
                    left: leftSection === '{{title}}' ? { title: customLeftTitle }
                        : (leftSection === '{{date}}' ? { date: leftDateFormat }
                            : leftSection === '{{pageNumber}}' ? { pageNumber: leftPageNumberPrefix }
                                : leftSection === '{{pageNumber / totalPages}}' ? { pageOfPages: leftPageSetuprPrefix }
                                    : { default: leftSection }), // Fallback to include default

                    middle: middleSection === '{{title}}' ? { title: customMiddleTitle }
                        : (middleSection === '{{date}}' ? { date: middleDateFormat }
                            : middleSection === '{{pageNumber}}' ? { pageNumber: middlePageNumberPrefix }
                                : middleSection === '{{pageNumber / totalPages}}' ? { pageOfPages: middlePageSetupPrefix }
                                    : { default: middleSection }), // Fallback to include default

                    right: rightSection === '{{title}}' ? { title: customRightTitle }
                        : rightSection === '{{date}}' ? { date: rightDateFormat }
                            : rightSection === '{{pageNumber}}' ? { pageNumber: rightPageNumberPrefix }
                                : rightSection === '{{pageNumber / totalPages}}' ? { pageOfPages: rightPageSetupPrefix }
                                    : { default: rightSection } // Fallback to include default

                },
                font: {
                    size: fontSize,
                    style: fontStyle,
                    color: fontColor
                }
            };

            setLocalStorageItem('pdfConfig', JSON.stringify(config));
        } catch (error) {
            console.error('Error generating PDF configuration:', error);
        }
    };


    const getJson = () => {
        let config = null;

        try {
            config = getLocalStorageItem('pdfConfig'); // Assuming this function fetches config from localStorage
        } catch (error) {
            console.error('Error retrieving pdfConfig from localStorage:', error);
        }

        // If config is null or not retrieved, create a default config
        if (!config) {
            try {

                const leftHeaderSection = "";
                const centerHeaderSection = "";
                const rightHeaderSection = "";

                const leftSection = "";
                const middleSection = 'format_xy' // Adjusted as per the JSON
                const rightSection = "";

                const topMargin = '10'; // Default to 0
                const topMarginUnit = 'px';

                const bottomMargin = '5'; // Default to 0
                const bottomMarginUnit = 'px';

                const leftMargin = '25'; // Default to 0
                const leftMarginUnit = 'px';

                const rightMargin = '20'; // Default to 0
                const rightMarginUnit = 'px';

                const pageSize = getPageSizeByLocale(); // Assuming this is a function that returns the page size like "Letter"

                const fontSize = '14';
                const fontStyle = 'normal';
                const fontColor = '#000000';

                config = {
                    pageSize,
                    margins: {
                        top: `${topMargin}${topMarginUnit}`,
                        bottom: `${bottomMargin}${bottomMarginUnit}`,
                        left: `${leftMargin}${leftMarginUnit}`,
                        right: `${rightMargin}${rightMarginUnit}`
                    },
                    header: {
                        left: { default: leftHeaderSection },
                        center: { default: centerHeaderSection },
                        right: { default: rightHeaderSection }
                    },
                    footer: {
                        left: { default: leftSection },
                        middle: { pageOfPages: middleSection }, // Adjusted middle section to match your JSON
                        right: { default: rightSection }
                    },
                    font: {
                        size: fontSize,
                        style: fontStyle,
                        color: fontColor
                    }
                };

                return JSON.stringify(config);
            } catch (error) {
                console.error('Error generating default footer configuration:', error);
            }
        }

        // Return JSON string with pretty printing
        try {
            return config;
        } catch (error) {
            console.error('Error serializing config to JSON:', error);
            return null; // Return null if serialization fails
        } finally {
            // Final cleanup
            config = null;
        }
    };

    const getBottomMargins = () => {
        let config = null;
        let righttheme = false;

        try {
            const configTemp = getJson(); // Retrieve JSON from localStorage or other sources
            config = JSON.parse(configTemp);
        } catch (error) {
            console.error('Error retrieving pdfConfig from localStorage:', error);
            return 45; // Default padding if parsing fails
        }

        // If config is null or not retrieved, return a default padding
        if (!config) {
            console.warn('No configuration found, returning default margins.');
            return 45; // Default bottom margin
        }

        let bottomMargin = 45; // Default value

        // Ensure config has margins property
        if (config.margins) {
            const bottom = convertToPixels(config.margins.bottom);
            bottomMargin = 45 + Math.floor(bottom);

            // Cleanup temporary variables for GC
            config.margins.bottom = null;
        }

        // Cleanup variables for GC
        config.margins = null;
        config = null;
        righttheme = null;

        return bottomMargin; // Return the final bottom margin
    };


    const getMargins = () => {
        let config = null;
        let righttheme = false;

        try {
            const configTemp = getJson(); // Function to retrieve JSON from localStorage or other sources
            config = JSON.parse(configTemp);
        } catch (error) {
            console.error('Error retrieving pdfConfig from localStorage:', error);
            return 'padding: 0px;'; // Return default padding if parsing fails
        }

        // If config is null or not retrieved, return a default padding
        if (!config) {
            console.warn('No configuration found, returning default margins.');
            return 'padding: 0px;';
        }

        // Ensure config has margins property
        if (config.margins) {
            const top = convertToPixels(config.margins.top);
            const bottom = convertToPixels(config.margins.bottom);
            const left = convertToPixels(config.margins.left);
            const right = convertToPixels(config.margins.right);

            var righttdpaddingleft = 20;
            var righttoppaddingleft = 20;

            const target = $("#builder_iframe").contents().find('#maincontent-body-html')[0];
            if (target) {
                const data = target.getAttribute('data').split("|");
                const className = data[0];
                if (className && className.includes('onecolumn')) {
                    righttdpaddingleft = left;
                }
                else if (className && (className === 'lefttdbodythemenophototopbox' || className === 'lefttdbodywhitebluethemenophoto')) {
                    righttoppaddingleft = left;

                }
                else if (className && className.startsWith('right')) {
                    righttheme = true;
                }
            }

            // Create the paddingConfig object with the converted values
            const paddingConfig = {
                leftdivpadding: {
                    top: 0, // Assuming 0 as default for unspecified values
                    right: 25, // Use default or specific values if needed
                    bottom: 0,
                    left: left
                },
                righttdpadding: {
                    top: 0,
                    right: right,
                    bottom: 0,
                    left: righttdpaddingleft // Default left value
                },
                righttoppadding: {
                    top: top,
                    right: right,
                    bottom: 0, // Include bottom padding if needed
                    left: righttoppaddingleft // Default left value
                }
            };

            // This is for right styles
            const rightpaddingConfig = {
                leftdivpadding: {
                    top: 0, // Assuming 0 as default for unspecified values
                    right: right, // Use default or specific values if needed
                    bottom: 0,
                    left: 25
                },
                righttdpadding: {
                    top: 0,
                    right: righttdpaddingleft,
                    bottom: 0,
                    left: left // Default left value
                },
                righttoppadding: {
                    top: top,
                    right: 20,
                    bottom: 0, // Include bottom padding if needed
                    left: left // Default left value
                }
            };

            if (righttheme)
                updatePaddingWithConfig(rightpaddingConfig, config.pageSize);
            else
                updatePaddingWithConfig(paddingConfig, config.pageSize); //update the value directly to the html only bottom margin is set at the print

            // Clean up temporary variables
            rightpaddingConfig.leftdivpadding = null;
            rightpaddingConfig.righttdpadding = null;
            rightpaddingConfig.righttoppadding = null;
            paddingConfig.leftdivpadding = null;
            paddingConfig.righttdpadding = null;
            paddingConfig.righttoppadding = null;

            // Set objects and variables to null for GC
            config = null;
            righttheme = null;
            righttdpaddingleft = null;
            righttoppaddingleft = null;

            // Optionally, return the padding configuration as a string if needed elsewhere
            return `padding: ${top}px ${right}px ${bottom}px ${left}px;`;
        } else {
            console.warn('Margins not found in configuration, returning default margins.');
            return 'padding: 0px;';
        }
    };

    const updatePaddingWithConfig = (config, pageSize) => {
        // Select the element to update (e.g., the element with ID "main-table")


        // Default values for each variable
        const defaultLeftDivPadding = {
            top: 0,
            right: 25,
            bottom: 0,
            left: 25
        };
        const defaultRightTdPadding = {
            top: 0,
            right: 20,
            bottom: 0,
            left: 20
        };
        const defaultRightTopPadding = {
            top: 30, // This will be used in calc
            right: 10,
            bottom: 0, // Example value if --bottomtoppadding is not defined elsewhere
            left: 20
        };

        // Destructure the config for each padding setting
        const {
            leftdivpadding = {},
            righttdpadding = {},
            righttoppadding = {}
        } = config;


        let topOffset = 0;
        if (window.location.href.includes("coverletter")) {
            topOffset = 10;
        }


        // Helper function to merge default values with provided values
        const mergePadding = (defaults, overrides) => ({
            top: overrides.top !== undefined ? overrides.top : defaults.top,
            right: overrides.right !== undefined ? overrides.right : defaults.right,
            bottom: overrides.bottom !== undefined ? overrides.bottom : defaults.bottom,
            left: overrides.left !== undefined ? overrides.left : defaults.left
        });



        // Merge provided values with defaults
        const leftDivPadding = mergePadding(defaultLeftDivPadding, leftdivpadding);
        const rightTdPadding = mergePadding(defaultRightTdPadding, righttdpadding);
        const rightTopPadding = mergePadding(defaultRightTopPadding, righttoppadding);

        // Helper function to convert padding values to CSS string
        const paddingToString = (padding) => {
            return `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`;
        };

        // Create style string
        const leftDivPaddingValue = paddingToString(leftDivPadding);
        const rightTdPaddingValue = paddingToString(rightTdPadding);
        const rightTopPaddingValue = `calc(${rightTopPadding.top + topOffset}px + var(--rightoffset)) ${rightTopPadding.right}px var(--bottomtoppadding) ${rightTopPadding.left}px`;
        const imagePaddingTop = `${rightTopPadding.top - 1}px`;

        let mindivheight;

        if (pageSize === 'A4') {
            mindivheight = '1240px';
        } else if (pageSize === 'Letter') {
            mindivheight = '1110px';
        } else if (pageSize === 'Legal') {
            mindivheight = '1460px';
        } else {
            mindivheight = '1200px'; // Default value
        }

        // Construct the full style string
        const paddingStyle = `
            --leftdivpadding: ${leftDivPaddingValue};
            --righttdpadding: ${rightTdPaddingValue};
            --righttoppadding: ${rightTopPaddingValue};
        `;

        const mainTable = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table');


        if (mainTable.length) {
            const styleTagContent = `
        .main-table-class {
            --leftdivpadding: ${leftDivPaddingValue};
            --righttdpadding: ${rightTdPaddingValue};
            --righttoppadding: ${rightTopPaddingValue};
            --image-padding-top: ${imagePaddingTop};
            --min-div-height: ${mindivheight};
            }
        `


            // Select the iframe's head
            const iframeHead = $("#builder_iframe").contents().find("html").find('head');

            // Check if the style tag already exists
            let existingStyleTag = iframeHead.find('#padding-style');

            if (existingStyleTag.length) {
                // Update the content of the existing style tag directly
                existingStyleTag.html(styleTagContent);
            } else {
                // Create a new style tag if it doesn't exist and add an ID for future reference
                const newStyleTag = `<style id="padding-style">${styleTagContent}</style>`;
                iframeHead.append(newStyleTag);
                console.log('new styles');
            }

            mainTable.css({
                '--leftdivpadding': leftDivPaddingValue,
                '--righttdpadding': rightTdPaddingValue,
                '--righttoppadding': rightTopPaddingValue,
                '--image-padding-top': imagePaddingTop,
                '--min-div-height': mindivheight
            });

            existingStyleTag = null;

            // Now extract the outerHTML, which will include the style tag
            // const content = $("#builder_iframe").contents().find("html")[0].outerHTML;
            //console.log('content', content);
            mainTable.click();
        }
        // Cleanup: Nullify references for GC
        config = null;
        pageSize = null;
        topOffset = null;

        // Nullify merged objects
        leftDivPadding.top = null;
        leftDivPadding.right = null;
        leftDivPadding.bottom = null;
        leftDivPadding.left = null;

        rightTdPadding.top = null;
        rightTdPadding.right = null;
        rightTdPadding.bottom = null;
        rightTdPadding.left = null;

        rightTopPadding.top = null;
        rightTopPadding.right = null;
        rightTopPadding.bottom = null;
        rightTopPadding.left = null;
        mindivheight = null;


    };





    const getPageSize = () => {
        let config = null;

        try {
            const configTemp = getJson();
            config = JSON.parse(configTemp);
        } catch (error) {
            console.error('Error retrieving pdfConfig from localStorage:', error);
            return null; // Return null if there was an error
        }

        // If config is null or not retrieved, create a default margins object
        if (!config) {
            console.warn('No configuration found, returning default margins.');

            return getPageSizeByLocale();  // Default padding when no config found
        }

        // Ensure config has margins property
        if (config.pageSize) {
            return config.pageSize
        } else {
            console.warn('PageSize not found in configuration, returning default margins.');

            return getPageSizeByLocale();  // Default padding when margins not found
        }
    };


    // Function to convert different units to pixels
    const convertToPixels = (marginValue) => {
        // Extract the numeric value and unit from the input
        const value = parseFloat(marginValue);
        const unit = marginValue.replace(/[0-9.]/g, '').trim(); // Get the unit part

        switch (unit) {
            case 'in': // Inches to pixels
                return value * 96; // 1 inch = 96 pixels
            case 'cm': // Centimeters to pixels
                return value * 37.795; // 1 cm = 37.795 pixels
            case 'mm': // Millimeters to pixels
                return value * 3.7795; // 1 mm = 3.7795 pixels
            case 'px': // Pixels to pixels
                return value; // Already in pixels
            default: // Fallback for any unspecified units
                return value; // Return the value as is (assumed to be in pixels already)
        }
    };

    // Function to replace placeholders in the format string
    const replacePlaceholders = (format) => {
        return format
            .replace(/X/g, '<span class="pageNumber"></span>')
            .replace(/Y/g, '<span class="totalPages"></span>');
    };

    // Function to generate a header template based on local storage
    const generateHeaderTemplate = () => {
        const configTemp = getJson(); // Fetch the JSON configuration
        const config = JSON.parse(configTemp);

        if (!config) {
            console.error("No PDF configuration found in local storage.");
            // Always return a template with empty values if no config is found
            return `
            <div style="border-bottom: solid 0px #bbb; width: 100%; font-size: 14px; padding: 0px 25px 10px 25px; margin-top: -2px; color: #bbb; position: relative; display: flex; justify-content: space-between; font-weight: normal; font-style: normal; text-decoration: none;">
                <div style="flex: 1; text-align: left;">
                    <span></span>
                </div>
                <div style="flex: 1; text-align: center;">
                    <span></span>
                </div>
                <div style="flex: 1; text-align: right;">
                    <span></span>
                </div>
            </div>
        `;
        }

        // Function to parse header content based on the config
        function parseHeaderContent(section) {
            // Check if section is an object with a default property
            if (section && typeof section === 'object' && section.default !== undefined) {
                return section.default; // Use the default value
            }
            return ''; // Return empty string if section is empty or undefined
        }

        const leftContent = parseHeaderContent(config.header.left);
        const centerContent = parseHeaderContent(config.header.center);
        const rightContent = parseHeaderContent(config.header.right);

        // Get font settings
        const fontSize = config.font.size ? `${config.font.size}px` : '14px';
        const fontWeight = config.font.style === 'bold' ? 'bold' : 'normal'; // Adjust for bold
        const fontStyle = config.font.style === 'italic' ? 'italic' : 'normal'; // Adjust for italics
        const textDecoration = config.font.style === 'underline' ? 'underline' : 'none'; // Adjust for underline
        const fontColor = config.font.color || '#bbb'; // Default color

        // Generate the header template with the parsed content
        const returnString = `
        <div style="border-bottom: solid 0px #bbb; width: 100%; font-size: ${fontSize}; padding: 0px 25px 10px 25px;  margin-top: -2px; color: ${fontColor}; position: relative; display: flex; justify-content: space-between; font-weight: ${fontWeight}; font-style: ${fontStyle}; text-decoration: ${textDecoration};">
            <div style="flex: 1; text-align: left;">
                <span>${leftContent}</span>
            </div>
            <div style="flex: 1; text-align: center;">
                <span>${centerContent}</span>
            </div>
            <div style="flex: 1; text-align: right;">
                <span>${rightContent}</span>
            </div>
        </div>
    `;

        return returnString;
    };




    // Function to generate a footer template based on local storage
    const generateFooterTemplate = () => {
        const configTemp = getJson();
        const config = JSON.parse(configTemp);

        if (!config) {
            console.error("No PDF configuration found in local storage.");
            return '';
        }

        // Function to parse footer content based on the config
        function parseFooterContent(section) {
            //console.log ('section is:', section);
            // Check if section is an object with a default property
            if (typeof section === 'object' && section.default) {
                section = section.default; // Use the default value
            }

            if (section.title) {
                return section.title; // Return the title if defined
            } else if (section.date) {
                // Return the formatted date
                return '<span>' + formatDate(section.date) + '</span>';
            } else if (section === '') {
                return ''; // Return empty string if section is empty
            }
            else if (section.pageOfPages) {
                const translatedPageOfPages = getI18n(section.pageOfPages);
                // console.log('pageOfPages', section.pageOfPages);
                if (translatedPageOfPages === 'None' || translatedPageOfPages === '') {
                    return '<span class="pageNumber"></span>/<span class="totalPages"></span>';
                } else if (section.pageOfPages) {
                    // Replace placeholders X and Y
                    const formattedContent = replacePlaceholders(translatedPageOfPages);
                    return formattedContent; // Return the formatted content with placeholders
                } else return '';
            } else if (section.pageNumber) {
                const translatedPageNumber = getI18n(section.pageNumber);
                const prefix = translatedPageNumber === 'None' ? '' : translatedPageNumber;
                return `${prefix}<span class="pageNumber"></span>`; // Return span for page number
            }
            return ""; // Fallback for other cases
        }

        // Function to format the date based on selected format using native JavaScript
        function formatDate(dateFormat) {
            const now = new Date();
            const options = {};

            switch (dateFormat) {
                case 'MM/DD/YYYY':
                    options.year = 'numeric';
                    options.month = '2-digit';
                    options.day = '2-digit';
                    break;
                case 'DD/MM/YYYY':
                    options.year = 'numeric';
                    options.month = '2-digit';
                    options.day = '2-digit';
                    break;
                case 'YYYY-MM-DD':
                    options.year = 'numeric';
                    options.month = '2-digit';
                    options.day = '2-digit';
                    break;
                default:
                    return now.toLocaleDateString(); // Fallback to default locale date format
            }

            const formattedDate = new Intl.DateTimeFormat('en-US', options).format(now);

            // If the format is DD/MM/YYYY or YYYY-MM-DD, rearrange the date string accordingly
            if (dateFormat === 'DD/MM/YYYY') {
                const parts = formattedDate.split('/');
                return `${parts[1]}/${parts[0]}/${parts[2]}`;
            } else if (dateFormat === 'YYYY-MM-DD') {
                const parts = formattedDate.split('/');
                return `${parts[2]}-${parts[0]}-${parts[1]}`;
            }

            return formattedDate; // Return the formatted date
        }

        const leftContent = parseFooterContent(config.footer.left);
        const middleContent = parseFooterContent(config.footer.middle);
        const rightContent = parseFooterContent(config.footer.right);

        // Get font settings
        const fontSize = config.font.size ? `${config.font.size}px` : '14px';
        const fontWeight = config.font.style === 'bold' ? 'bold' : 'normal'; // Adjust for bold
        const fontStyle = config.font.style === 'italic' ? 'italic' : 'normal'; // Adjust for italics
        const textDecoration = config.font.style === 'underline' ? 'underline' : 'none'; // Adjust for underline
        const fontColor = config.font.color || '#bbb'; // Default color

        const returnString = `
                <div style="border-top: solid 0px #bbb; width: 100%; font-size: ${fontSize}; padding: 25px 25px 2px 25px; color: ${fontColor}; position: relative; display: flex; justify-content: space-between; font-weight: ${fontWeight}; font-style: ${fontStyle}; text-decoration: ${textDecoration};">
                    <div style="flex: 1; text-align: left;">
                        <span>${leftContent}</span>
                    </div>
                    <div style="flex: 1; text-align: center;">
                        <span>${middleContent}</span>
                    </div>
                    <div style="flex: 1; text-align: right;">
                        ${rightContent}
                    </div>
                </div>
            `;
        //  console.log('returnString', returnString);
        return returnString;
    }

    const loadPDFConfig = () => {
        try {
            const config = getJson();
            if (config) {
                const parsedConfig = JSON.parse(config);

                // Safely set values with null checks
                document.getElementById('page-setup-page-size').value = parsedConfig.pageSize || '';

                const setMarginUnit = (margin) => {
                    const unit = parsedConfig.margins[margin].replace(/[0-9.]/g, '') || 'px';
                    document.getElementById(`page-setup-${margin}-margin-unit`).value = unit;
                    populateMargins(margin);
                };

                const setMarginValue = (margin) => {
                    document.getElementById(`page-setup-${margin}-margin`).value = parsedConfig.margins[margin].replace(/[^\d.-]/g, '') || '0';
                };

                // Set margin units and values
                ['top', 'bottom', 'left', 'right'].forEach(margin => {
                    setMarginUnit(margin);
                    setMarginValue(margin);
                });

                // Set header values
                const setHeaderValue = (section, inputId) => {
                    const value = parsedConfig.header[section]?.default || '';
                    const input = document.getElementById(inputId);
                    if (input) {
                        input.value = value;
                    }
                };

                // Set values for left, center, and right headers
                setHeaderValue('left', 'page-setup-left-header');
                setHeaderValue('center', 'page-setup-center-header');
                setHeaderValue('right', 'page-setup-right-header');


                // Set footer section values
                const setSectionValue = (section, titleId, formatId, numberId, prefixId) => {
                    const value = parsedConfig.footer[section] || {};
                    const dropdown = document.getElementById(`page-setup-${section}-section`);

                    //    console.log('value.pageNumber', value.pageNumber);

                    // Determine dropdown value based on properties
                    dropdown.value = value.title ? '{{title}}' : value.date ? '{{date}}' : value.pageNumber ? '{{pageNumber}}' : value.pageOfPages ? '{{pageNumber / totalPages}}' : value.default ? value.default : '';

                    const titleInputSection = document.getElementById(titleId);
                    const dateFormatSection = document.getElementById(formatId);
                    const numberDropdownSection = document.getElementById(numberId);
                    const prefixDropdownSection = document.getElementById(prefixId);

                    if (titleInputSection && value.title) {
                        titleInputSection.value = value.title; // Set custom title if applicable
                    }

                    if (dateFormatSection && value.date) {
                        dateFormatSection.value = value.date; // Set date format if applicable
                    }

                    // Set the page number prefix value if it exists
                    if (numberDropdownSection && value.pageNumber) {
                        numberDropdownSection.value = value.pageNumber; // Set page number prefix
                    }

                    // Set the page number prefix value if it exists
                    if (prefixDropdownSection && value.pageOfPages) {
                        //   console.log('value.pageOfPages', value.pageOfPages);
                        prefixDropdownSection.value = value.pageOfPages; // Set page number prefix
                    }
                };

                // Set values for left, middle, and right sections
                setSectionValue('left', 'page-setup-left-custom-title', 'page-setup-left-date-format', 'page-setup-left-number', 'page-setup-left-prefix');
                setSectionValue('middle', 'page-setup-middle-custom-title', 'page-setup-middle-date-format', 'page-setup-middle-number', 'page-setup-middle-prefix');
                setSectionValue('right', 'page-setup-right-custom-title', 'page-setup-right-date-format', 'page-setup-right-number', 'page-setup-right-prefix');

                // Load font settings
                document.getElementById('page-setup-font-size').value = parsedConfig.font.size || '12'; // Default to 12px
                document.getElementById('page-setup-font-style').value = parsedConfig.font.style || 'normal'; // Default to normal
                document.getElementById('page-setup-font-color').value = parsedConfig.font.color || '#000000'; // Default to black

                // Call visibility function to ensure UI is updated
                handleTitleInputVisibility();
            }
        } catch (error) {
            console.error('Error loading PDF configuration:', error);
        }
    };

    const save = () => {
        try {
            generatePDFConfig();
            getMargins();
            generateFooterTemplate();
            close();
        } catch (error) {
            console.error('Error saving PDF configuration:', error);
        }
    };

    const close = () => {
        try {
            modal = document.getElementById("page-setup-myModal");
            hideModalBackDrop();
            if (modal) {
                modal.style.display = "none";
            }
        } catch (error) {
            console.error('Error closing modal:', error);
        }
    };


    const init = () => {
        try {
            modal = document.getElementById("page-setup-myModal");
            closeButton = document.getElementsByClassName("page-setup-close")[0];

            if (closeButton) {
                closeButton.onclick = () => {
                    hideModalBackDrop();
                    close(); // Call close function
                };
            }
        } catch (error) {
            console.error('Error initializing PDFConfigModule:', error);
        }
    };

    const openModal = () => {
        try {
            showModalBackDrop();
            if (modal) {
                modal.style.display = "flex";
                populateMargins('top');
                populateMargins('left');
                populateMargins('right');
                populateMargins('bottom');
                document.getElementById('page-setup-page-size').value = getPageSizeByLocale();

                setCustomTimeout(() => {
                    loadPDFConfig();
                    handleTitleInputVisibility(); // Hide title and date format sections initially
                }, 20);
            }
        } catch (error) {
            console.error('Error opening modal:', error);
        }
    };



    return {
        openModal,
        init,
        handleTitleInputVisibility,
        generatePDFConfig,
        close,
        populateMargins,
        save,
        generateFooterTemplate,
        getMargins,
        getPageSize,
        generateHeaderTemplate,
        getBottomMargins
    };
})();

// Expose openModal for external use
export { PDFConfigModule };
